import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import moment from 'moment';

const generateDate = () => (
	moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ')
);

const Node = (props) => {
	const properties = props.properties ? (
		<properties>
			{Object.keys(props.properties).map((TagName, index) => (
				<TagName key={index} __type="string">{props.properties[TagName]}</TagName>
			))}
		</properties>
	) : <properties />;

	const dimensions = props.dimensions ? (
		<dimensions>
			{Object.keys(props.dimensions).map((DimensionName, index) => (
				<DimensionName key={index}>{props.dimensions[DimensionName]}</DimensionName>
			))}
		</dimensions>
	) : <dimensions />;

	return (
		<node identifier={uuid()} nodename={props.nodeName}>
			<variant sortingindex="100" workspace="live" nodetype={props.nodeType} version="1" removed="" hidden="1" hiddeninindex="">
				{dimensions}
				<accessroles __type="array"/>
				<creationdatetime __type="object" __classname="DateTime">{generateDate()}</creationdatetime>
				<lastmodificationdatetime __type="object" __classname="DateTime">{generateDate()}</lastmodificationdatetime>
				<lastpublicationdatetime __type="object" __classname="DateTime">{generateDate()}</lastpublicationdatetime>
				{properties}
			</variant>
			{props.children ? props.children : null}
		</node>
	);
};

Node.propTypes = {
	nodeName: PropTypes.string.isRequired,
	nodeType: PropTypes.string.isRequired,
	properties: PropTypes.object,
	dimensions: PropTypes.object,
	children: PropTypes.object
};

export default Node;



// WEBPACK FOOTER //
// ./src/components/Xml/Node.js